import { Link } from "react-router-dom";
import Logo from "./Logo";
import LangSwitcher from "./LangSwitcher";
import { useLanguage } from "../context/LanguageContext";
import { CONTACT } from "../constants/site";

const NAV = [
  { id: "home", to: "/" },
  { id: "about", to: "/about" },
  { id: "fleet", to: "/fleet" },
  { id: "services", to: "/services" },
  { id: "driver", to: "/driver" },
  { id: "contact", to: "/contact" },
  { id: "journal", to: "/blog" }
];

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050506]">
      <div className="mx-auto max-w-7xl px-5 lg:px-10 py-16 lg:py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-[26ch]">{t.footer.tagline}</p>
          <LangSwitcher className="mt-6 inline-flex" />
        </div>

        <div>
          <h3 className="eyebrow">{t.footer.navigate}</h3>
          <ul className="mt-5 space-y-3">
            {NAV.map(({ id, to }) => (
              <li key={id}>
                <Link
                  to={to}
                  data-testid={`footer-link-${id}`}
                  className="text-sm text-slate-300 hover:text-gold-soft transition-colors duration-300"
                >
                  {t.nav[id]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="eyebrow">{t.footer.servicesTitle}</h3>
          <ul className="mt-5 space-y-3">
            {t.servicesPage.items.map((s) => (
              <li key={s.id}>
                <Link
                  to="/services"
                  data-testid={`footer-service-${s.id}`}
                  className="text-sm text-slate-300 hover:text-gold-soft transition-colors duration-300"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="eyebrow">{t.footer.contactTitle}</h3>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li>{CONTACT.address}</li>
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="hover:text-gold-soft transition-colors">
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-gold-soft transition-colors">
                {CONTACT.email}
              </a>
            </li>
            <li className="font-mono2 text-xs text-gold-soft tracking-[0.15em] uppercase">{t.contact.dispatchValue}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/8">
        <div className="mx-auto max-w-7xl px-5 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p data-testid="footer-rights" className="font-mono2 text-[11px] tracking-[0.15em] text-slate-500">
            © {year} MIRAL GROUP — {t.footer.rights}
          </p>
          <p className="font-mono2 text-[11px] tracking-[0.15em] text-slate-500">
            {t.hero.badge}
          </p>
        </div>
      </div>
    </footer>
  );
}
